// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"2905e507","288":"0d20a014","439":"c171f028","746":"11aa7b3c","855":"5ffc9dd4"}[chunkId] + ".chunk.js";
};